import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_CUBEDEX_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Function to set the access token
const setAccessToken = (accessToken) => {
  if (accessToken) {
    api.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
  } else {
    delete api.defaults.headers.common["Authorization"];
  }
};

export { api, setAccessToken };
